import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TwoLines } from '../../components/layout/layoutElements';
import { FormItemEnumRadioGroup } from '../../components/forms/checkable';
import { useShipmentDetailLocalizedDateTimeStyles } from './ShipmentDetailLocalizedDateTime.styles';

export default function ShipmentDetailLocalizedDateTime({ value, onChange }) {
  const { styles } = useShipmentDetailLocalizedDateTimeStyles();
  return (
    <div>
      <TwoLines className="size-6" />
      <div className={styles.localizedDateTime}>
        <div className={styles.localizedDateTimeTitle}>
          <FormattedMessage id="shipmentDetail.activityLog.label" />:
        </div>
        <FormItemEnumRadioGroup
          intlPrefix="shipmentDetail.activityLog"
          intlValues={['local', 'event-location']}
          formItemComponentProps={{
            value,
            onChange,
          }}
          noStyle
        />
      </div>
    </div>
  );
}
